import { useCallback } from 'react'
import { Inspection } from '~/shared/api'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Filter } from '~/shared/ui/AsyncGrid'
import { useFiltersQueryParams } from '~/shared/ui/AsyncGrid/Filters'
import { FileExportBlob } from '~/shared/ui/FileExport'

type InspectionExportProps = { filters: Filter[] }

const FILTER_KEY_MAP: Record<string, string> = {
  responsibleName: 'filter[responsible][name]',
  carId: 'filter[car][id]',
  carVin: 'filter[car][vin]',
  reasonId: 'filter[reason][id]',
  regionId: 'filter[subdivision][region][id]',
  subdivisionId: 'filter[subdivision][id]',
}

export const InspectionExport = ({ filters }: InspectionExportProps) => {
  const [filtersQueryParams] = useFiltersQueryParams(filters)

  const queryFilters = Object.fromEntries(
    Object.entries(filtersQueryParams)
      .map(([key, value]) => {
        const apiKey = FILTER_KEY_MAP[key] ?? `filter[${key}]`
        return [apiKey, (value as { id?: string })?.id ?? value]
      })
      .filter(([, value]) => Boolean(value)),
  )

  const queryFiltersKey = JSON.stringify(queryFilters)

  const handleExportFn = useCallback((): Promise<Blob> | void => {
    if (
      !filtersQueryParams.finishedAtDateGte ||
      !filtersQueryParams.finishedAtDateLte
    ) {
      snackbarEnqueued({
        messageI18n: 'alert.set inspection date filter',
        variant: 'error',
      })
      return
    }

    return Inspection.exportExcel(
      new URLSearchParams(queryFilters as Record<string, string>).toString(),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filtersQueryParams.finishedAtDateGte,
    filtersQueryParams.finishedAtDateLte,
    queryFiltersKey,
  ])

  return <FileExportBlob titleI18n='button.export excel' fn={handleExportFn} />
}
